import { Environment } from "../../../environments/Environment";
import { axiosInstance as axios } from "../../interceptor/useAxiosInterceptors";

export const CreateOrUpdateGoal = async (payload) => {
  try {
    const response = await axios.post(
      `${Environment.apiUrl}/basicgoals/saveGoal`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error in CreateOrUpdateGoal:", error);
    throw error;
  }
};

export const DeleteGoal = async (data) => {
  try {
    const response = await axios.post(
      `${Environment.emsUrl}/employee/getAllEmployeesByStatus`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error in GetEmployeesByStatus:", error);
    throw error;
  }
};

export const GetAllGoals = async (payload) => {
  try {
    const response = await axios.post(
      `${Environment.apiUrl}/basicgoals/searchGoals`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error in GetAllGoals:", error);
    throw error;
  }
};
export const searchEmployeeForGoal = async (name) => {
  try {
    const response = await axios.get(
      `${Environment.emsUrl}/employee/searchEmployeeForGoal?input=${name}`
    );
    return response.data;
  } catch (error) {
    console.error("Error in Search Employee For Goal:", error);
    throw error;
  }
};
export const initiateGoalSetup = async (payload) => {
  try {
    const response = await axios.post(
      `${Environment.emsUrl}/goalsetup/initiateGoalSetup`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error while Initiating Goal Setup:", error);
    throw error;
  }
};
export const searchGoals = async (payload) => {
  try {
    const response = await axios.post(
      `${Environment.emsUrl}/goalsetup/searchGoals`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error while fetching data from search Goals:", error);
    throw error;
  }
};
export const setUpGoals = async (payload) => {
  try {
    const response = await axios.post(
      `${Environment.emsUrl}/goalsetup/setUpGoals`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error while fetching data from setup Goals:", error);
    throw error;
  }
};
